import { ROUTE_LOGIN_OUT } from "@/constants/routes.constants";
import { Button } from "@/shadcn/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shadcn/components/ui/dialog";
import React, { useState } from "react";
import { useNavigate } from "react-router";

type DialogLogOutProps = {
  children: React.ReactNode;
};

const DialogLogOut: React.FC<DialogLogOutProps> = ({ children }) => {
  // useState is used to control dialog open state for explicit control
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  // This function should handle the actual logout logic (e.g., clearing tokens, redirecting)
  const handleLogout = () => {
    // Placeholder for logout logic: this is where you would clear session and redirect
    // Using window.location for simplicity; in a real app, use router or auth context
    nav(ROUTE_LOGIN_OUT);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {/* The trigger button is rendered as provided by the parent */}
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Log Out</DialogTitle>
          {/* The message is specified to confirm user intent */}
          <DialogDescription>
            Are you sure you want to log off?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          {/* Cancel closes the dialog, returning user to dashboard */}
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          {/* Yes proceeds with logout */}
          <Button
            variant="default"
            onClick={() => {
              setOpen(false); // Close dialog before logout for UX smoothness
              handleLogout();
            }}
          >
            Yes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DialogLogOut;
